import 'reflect-metadata';
import {FormFieldMetadata, FormFieldOptionsModel} from '../../typings/models/form-field-options.model';
import {FORM_FIELD_METADATA_KEY} from '../constants/common.constants';


export function FormField(options: FormFieldOptionsModel) {
  return (target: any, propertyKey: string) => {
    // Get existing metadata or initialize an empty array
    const existingMetadata: FormFieldMetadata[] = Reflect.getMetadata(
      FORM_FIELD_METADATA_KEY,
      target.constructor
    ) || [];

    // Add new field metadata
    existingMetadata.push({
      key: propertyKey,
      ...options
    });

    // Store the updated metadata back on the class constructor
    Reflect.defineMetadata(
      FORM_FIELD_METADATA_KEY,
      existingMetadata,
      target.constructor
    );
  };
}
